module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/android11Logo.f36402e0.mp4";